const companyColumns = [
  {
    title: '客户ID',
    dataIndex: 'fcustId',
    key: 'fcustId',
    ellipsis: true
  },
  {
    title: '客户代码',
    dataIndex: 'fnumber',
    key: 'fnumber',
    ellipsis: true
  },
  {
    title: '客户名称',
    dataIndex: 'fname',
    key: 'fname',
    ellipsis: true
  },
  {
    title: '地址',
    dataIndex: 'fshrdz',
    key: 'fshrdz',
    ellipsis: true
  },
  {
    title: '联系人',
    dataIndex: 'fshr',
    key: 'fshr',
    ellipsis: true
  },
  {
    title: '手机号码',
    dataIndex: 'fshrdh',
    key: 'fshrdh'
  }
]

const machineColumns = [
  {
    title: '整机编号',
    dataIndex: 'machineId',
    key: 'machineId',
    ellipsis: true
  },
  {
    title: '机型',
    dataIndex: 'machineType',
    key: 'machineType',
    ellipsis: true
  },
  {
    title: '业务员',
    dataIndex: 'salesman',
    key: 'salesman',
    ellipsis: true
  },
  {
    title: '服务员',
    dataIndex: 'serviceName',
    key: 'serviceName',
    ellipsis: true
  },
  {
    title: '出厂日期',
    dataIndex: 'salesTime',
    key: 'salesTime'
  },
  {
    title: '保养时间',
    dataIndex: 'maintainSetTime',
    key: 'maintainSetTime'
  },
  {
    title: '每天运行时间',
    dataIndex: 'runtime',
    key: 'runtime'
  },
  {
    title: '价格',
    dataIndex: 'price',
    key: 'price'
  },
  {
    title: '上次保养日期',
    dataIndex: 'lastMaintainTime',
    key: 'lastMaintainTime'
  },
  {
    title: '下次保养日期',
    dataIndex: 'exceptMaintainDate',
    key: 'exceptMaintainDate'
  },
  {
    title: '剩余保养天数',
    dataIndex: 'maintainDate',
    key: 'maintainDate'
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    width: 100
  }
]

export {
  companyColumns,
  machineColumns
}
